import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { Popover, PopoverModule } from 'primeng/popover';
import { TooltipModule } from 'primeng/tooltip';
import { LayoutPane, LayoutPresetId, LayoutPresetType, PaneId } from '../../entity/layout-presets';
import { LayoutStateService } from '../../services/layout-state/layout-state.service';

interface LayoutOption {
  id: LayoutPresetId;
  label: string;
  panes: PaneId[];
}

@Component({
  selector: 'app-layout-chooser',
  standalone: true,
  imports: [CommonModule, PopoverModule, TooltipModule],
  templateUrl: './layout-chooser.component.html',
  styleUrls: ['./layout-chooser.component.scss']
})
export class LayoutChooserComponent {
  @ViewChild('layoutPopover') layoutPopover?: Popover;

  readonly activePresetId = this.layoutStateService.activePresetId;
  readonly paneShortLabels: Record<PaneId, string> = {
    [LayoutPane.RouteList]: 'RouteList',
    [LayoutPane.Gantt]: 'Gantt',
    [LayoutPane.Map]: 'Map'
  };
  readonly paneAriaLabels: Record<PaneId, string> = {
    [LayoutPane.RouteList]: 'Route List',
    [LayoutPane.Gantt]: 'Gantt',
    [LayoutPane.Map]: 'Map'
  };
  readonly layoutOptions: LayoutOption[] = [
    { id: LayoutPresetType.ThreePane, label: 'Route + Gantt + Map', panes: [LayoutPane.RouteList, LayoutPane.Gantt, LayoutPane.Map] },
    { id: LayoutPresetType.TwoPaneGantt, label: 'Route + Gantt', panes: [LayoutPane.RouteList, LayoutPane.Gantt] },
    { id: LayoutPresetType.TwoPaneMap, label: 'Route + Map', panes: [LayoutPane.RouteList, LayoutPane.Map] },
  ];

  isPopoverOpen = false;

  constructor(private readonly layoutStateService: LayoutStateService) {}

  isSelected(presetId: LayoutPresetId): boolean {
    return this.activePresetId() === presetId;
  }

  selectPreset(presetId: LayoutPresetId): void {
    this.layoutStateService.selectPreset(presetId);
    this.layoutPopover?.hide();
  }

  trackByPresetId(_: number, option: LayoutOption): LayoutPresetId {
    return option.id;
  }

  onPopoverShow(): void {
    this.isPopoverOpen = true;
  }

  onPopoverHide(): void {
    this.isPopoverOpen = false;
  }
}
